import { heureka } from "@otto-ec/heureka";
import { dereference } from "../tracking/FeatureTracking";
import { FilterSection } from "./FilterSection";

export function registerFilterSectionChangedListener() {
  heureka.filterSection_change.on((event) => {
    /*                                                                                              */
    /*                                                                                         */
    const referencingElements = referencingFeatures(event.target, FilterSection.template().filterSection);
    referencingElements.forEach((elem) => {
      elem.checked = event.target.checked;
    });
    const referenced = dereference(event.target);
    /*                           */
    /*                                                                        */
    if (referenced instanceof HTMLElement && referenced.tagName === "OC-CHIP-V3") {
      const facetValueInput = referenced.querySelector("input");
      facetValueInput.checked = event.target.checked;
      facetValueInput.dispatchEvent(new Event("change", { bubbles: true }));
    } else if (
      referenced &&
      (referenced instanceof HTMLInputElement ||
        (referenced instanceof HTMLElement &&
          referenced.classList.contains("hc_facetValueInput") &&
          "checked" in referenced))
    ) {
      referenced.checked = event.target.checked;
      /*                                                                                                  */
      referenced.dispatchEvent(new Event("change", { bubbles: true }));
    }
  });
}

/**
 *
 *
 *
 *
 *
 */
function referencingFeatures<E extends HTMLElement>(elem: E, rootElement?: ParentNode): E[] | undefined {
  if (!elem.dataset.tsFeatureRef) {
    return [];
  }
  return Array.from(
    (rootElement || document).querySelectorAll<E>(`[data-ts-feature-ref="${elem.dataset.tsFeatureRef}"]`),
  );
}
